import Box from '@mui/material/Box';
import { useTheme } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import useMediaQuery from '@mui/material/useMediaQuery';
import { Trans, useTranslation } from 'react-i18next';
import { countdownTimerStyles } from './countdownTimerStyles';

export interface ICountdownTimerProps {
  round?: number;
  days?: number;
  hours?: number;
  minutes?: number;
  seconds?: number;
}
export const CountDownTimer = ({
  round,
  days,
  hours,
  minutes,
  seconds
}: ICountdownTimerProps) => {
  const theme = useTheme();
  const { t } = useTranslation();
  const classes = countdownTimerStyles(theme);
  const isDownSm = useMediaQuery(theme.breakpoints.down('md'));

  const variantTitle = isDownSm ? 'h6' : 'h4';

  return (
    <Box sx={classes.allItems}>
      <Typography variant={variantTitle} sx={classes.title} component='div'>
        <Trans
          i18nKey={t(`vesting.card_data.round.title`, { round: round + 1 })}
          components={[
            <Typography
              component='span'
              variant={variantTitle}
              sx={classes.boldText}
            />
          ]}
        />
      </Typography>
      <Box sx={classes.container}>
        <Box sx={classes.allContainer}>
          <Box sx={classes.itemsContainer}>
            <Box>
              <Typography sx={classes.number}>
                {days.toString().padStart(2, '0')}
              </Typography>
            </Box>
            <Box sx={classes.containerSubtitle}>
              <Typography sx={classes.subtitle}>
                {days === 1
                  ? t('vesting.countdown_page.countdown.day.title.singular')
                  : t('vesting.countdown_page.countdown.day.title.plural')}
              </Typography>
            </Box>
          </Box>
        </Box>
        <Box sx={classes.allContainer}>
          <Box sx={classes.itemsContainer}>
            <Box>
              <Typography sx={classes.number}>
                {hours.toString().padStart(2, '0')}
              </Typography>
            </Box>
            <Box sx={classes.containerSubtitle}>
              <Typography sx={classes.subtitle}>
                {t('vesting.countdown_page.countdown.hours.title')}
              </Typography>
            </Box>
          </Box>
        </Box>
        <Box sx={classes.allContainer}>
          <Box sx={classes.itemsContainer}>
            <Box>
              <Typography sx={classes.number}>
                {minutes.toString().padStart(2, '0')}
              </Typography>
            </Box>
            <Box sx={classes.containerSubtitle}>
              <Typography sx={classes.subtitle}>
                {t('vesting.countdown_page.countdown.min.title')}
              </Typography>
            </Box>
          </Box>
        </Box>
        <Box sx={classes.allContainer}>
          <Box sx={classes.itemsContainer}>
            <Box>
              <Typography sx={classes.number}>
                {seconds.toString().padStart(2, '0')}
              </Typography>
            </Box>
            <Box sx={classes.containerSubtitle}>
              <Typography sx={classes.subtitle}>
                {t('vesting.countdown_page.countdown.sec.title')}
              </Typography>
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};
